import React from 'react';
import ReactDOM from 'react-dom/client';
import './assets/styles/bootstrap.custom.css';
import './assets/styles/index.css';
// import 'bootstrap/dist/css/bootstrap.min.css';
import App from './App';
//import AuthMonitor from './utils/authMonitorold';
//import InactivityTracker from './utils/inactivityTracker';
import reportWebVitals from './reportWebVitals';
import {
  createBrowserRouter,
  createRoutesFromElements,
  Route,
  RouterProvider,
} from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import PrivateRoute from './components/PrivateRoute';
import AdminRoute from './components/AdminRoute';
import HomeScreen from './screens/HomeScreen';
import ProductScreen from './screens/ProductScreen';
import CartScreen from './screens/CartScreen';
import LoginScreen from './screens/LoginScreen';
 
import ShiftCreateScreen from './screens/admin/ShiftCreateScreen';
import ShiftListScreen from './screens/admin/ShiftListScreen';
import ShiftEditScreen from './screens/admin/ShiftEditScreen';
import ShiftWardEditScreen from './screens/admin/ShiftWardEditScreen';
import ShiftWardListScreen from './screens/admin/ShiftWardListScreen2';
 
import ShiftWardEditScreenM from './screens/manager/AproveShift/ShiftWardEditScreen';
import ShiftWardListScreenM from './screens/manager/AproveShift/ShiftWardListScreen2';
import ShiftCompletedListScreenM from './screens/manager/AproveShift/ShiftCompletedListScreen';
import ManagerDashboard from './screens/manager/Dashboard/ManagerDashboard';
 
 
import ShiftCompletedListScreen from './screens/admin/CalendarViews/ShiftCompletedListScreen';
 
import UserShiftRequestScreen from './screens/ShiftRequestScreen';
import ShiftRequestScreen from './screens/admin/ShiftRequestScreen';
import ShiftRequestAgencyScreen from './screens/admin/ShiftRequestAgencyScreen';
 
import ShiftRequestAgencyNotificationScreen from './screens/admin/ShiftRequestAgencyNotificationScreen';
import ShiftApproveScreen from './screens/admin/ShiftApproveScreen';
 
import AgencyRegisterScreen from './screens/admin/AgencyRegisterScreen';
import RegisterScreen from './screens/RegisterScreen';
import ResetScreen from './screens/ResetScreen';
import ShippingScreen from './screens/ShippingScreen';
import PaymentScreen from './screens/PaymentScreen';
import PlaceOrderScreen from './screens/PlaceOrderScreen';
import OrderScreen from './screens/OrderScreen';
import ProfileScreen from './screens/ProfileScreen';
import StaffAvailabilityViewStaff  from './screens/StaffAvailabilityViewStaff';
 
import StaffRoster  from './screens/MyMonthlyView';
import AuditLogScreen from './screens/admin/AuditLogScreen';
 
 
 
 
import WorklistEditActivityScreen from './screens/WorklistEditActivityScreen';
import WorklistScreen from './screens/WorklistScreen';
import WorklistEditItemScreen from './screens/WorklistEditItemScreen';
//import TreeMapChart from './screens/TreeMap';
import TreeMapChart from './screens/TreeMap2';
import WorklistEditItemScreenM from './screens/manager/WorklistEditItemScreenM';
import WorklistEditScreen from './screens/WorklistEditScreen';
 
 
import SchedulingDashboard from './screens/admin/Dashboard/SchedulingDashboard';
import OrderListScreen from './screens/admin/OrderListScreen';
import ProductListScreen from './screens/admin/ProductListScreen';
import ProductEditScreen from './screens/admin/ProductEditScreen';
import UserListScreen from './screens/admin/UserListScreen';
import UserEditScreen from './screens/admin/UserEditScreen';
 
import RadUserListScreen from './screens/admin/RadAdmin/UserListScreen';
import RadUserEditScreen from './screens/admin/RadAdmin/UserEditScreen';
 
import store from './store';
import { Provider } from 'react-redux';
import { PayPalScriptProvider } from '@paypal/react-paypal-js';
 
import ActivityListScreen from './screens/admin/ActivityListScreen';
import ActivityEditScreen from './screens/admin/ActivityEditScreen';
import ClinicalSiteListScreen from './screens/admin/ClinicalSiteListScreen';
import ClinicalSiteEditScreen from './screens/admin/ClinicalSiteEditScreen';
 
import StaffWeeklyView from './screens/admin/CalendarViews/StaffWeeklyView';
import WardWeeklyView from './screens/admin/CalendarViews/WardWeeklyView';
import MonthlyCalendarView from './screens/admin/CalendarViews/MonthlyCalendarView';
 
import ClinicalDirectorListScreen from './screens/admin/ClinicalDirectorListScreen';
import ClinicalDirectorEditScreen from './screens/admin/ClinicalDirectorEditScreen';
 
import ClinicalSCommitmentListScreen from './screens/admin/ClinicalSCommitmentListScreen';
import ClinicalSCommitmentEditScreen from './screens/admin/ClinicalSCommitmentEditScreen';
 
 
 
import UserClinicalSCommitmentListScreen from './screens/UserClinicalCommitmentListScreen';
import UserClinicalSCommitmentEditScreen from './screens/UserClinicalSCommitmentEditScreen';
 
import SPQualListScreen from './screens/SPQualslistScreen';
import SPQualEditScreen from './screens/SPQualsEditScreen';
 
import ArcadeScreen from './screens/arcade-hub';
import SpsProfileScreen from './screens/SpsProfileScreen';






 
import RadiationSafetyListScreen from './screens/admin/RadAdmin/RadiationSafetyListScreen';
import RadiationSafetyEditScreen from './screens/admin/RadAdmin/RadiationSafetyEditScreen';
 
import UserRadiationSafetyListScreen from './screens/UserRadiationSafetyListScreen';
import UserRadiationSafetyEditScreen from './screens/UserRadiationSafetyEditScreen';
 
import DirectorateListScreen from './screens/admin/ADirectorateListScreen';
import DirectorateEditScreen from './screens/admin/ADirectorateEditScreen';
 
import LocationListScreen from './screens/admin/ALocationListScreen';
import LocationEditScreen from './screens/admin/ALocationEditScreen';
 
import SpecialityListScreen from './screens/admin/ASpecialityListScreen';
import SpecialityEditScreen from './screens/admin/ASpecialityEditScreen';
 
import HospitalLocationScreen from './screens/admin/HospitalLocationScreen';
 
 
import PrivilegesListScreen from './screens/admin/APrivileges'; 
import SpecialityPrivilegesListScreen from './screens/admin/ASpecialityPrivilegeList';
import PrivilegeEditScreen  from './screens/admin/APrivilegeEditScreen';
import SpecialityPrivilegesEditScreen from './screens/admin/ASpecialityPrivilegeEditScreen';
import AssignmentPrivilegesScreen from './screens/admin/AUserPrivliegeAssignmentScreen';
//import { Route, Routes } from 'react-router-dom';
import AgencyListScreen from './screens/admin/AgencyListScreen';
import AgencyFormScreen from './screens/admin/AgencyFormScreen';
 
import AgencyLoginScreen from './screens/admin/AgencyLoginScreen';
 
 
import StaffWeeklyViewM from './screens/manager/CalendarViews/StaffWeeklyView';
import WardWeeklyViewM from './screens/manager/CalendarViews/WardWeeklyView';
import MonthlyCalendarViewM from './screens/manager/CalendarViews/MonthlyCalendarView';
import StaffAvailabilityViewM from './screens/manager/CalendarViews/StaffAvailabilityView';
import ShiftCreateScreenM from './screens/manager/ShiftCreateScreenM';
 
//import ShiftListScreenM from './screens/manager/ShiftListScreenM';
import ShiftEditScreenM from './screens/manager/ShiftEditScreenM';
 
 
 
 
 
import ApproveWorklist from './screens/manager/UserListScreenM';
import ApprovedWorklist from './screens/manager/UsersApprovedScreenM';
import ApproveWorklistItem from './screens/manager/WorklistEditActivityScreenM';
import ManagerAssignmentPrivilegesScreen from './screens/manager/MUserPrivliegeAssignmentScreen';
import ManagerViewPrivilegesScreen from './screens/manager/MUserPrivilegeViewScreen';
import TreeMapMTeam from './screens/manager/TreeMapMTeam';
import ManagerReports from './screens/manager/managerReports';
import ManagerReportsList from './screens/manager/managerReportsList';
 
import WardPreShiftListScreenM from './screens/manager/WardPreShiftListScreenM';
import WardPreShiftCreateScreenM from './screens/manager/WardPreShiftCreateScreenM';
 
import RollingRosterView from './components/RollingRosterView';
 
 
import { LayoutProvider } from './context/LayoutContext';
 
import StaffAvailabilityView from './screens/admin/CalendarViews/StaffAvailabilityView';
  
// Add these routes to your router configuration
import WardPreShiftListScreen from './screens/admin/WardPreShiftListScreen';
import WardPreShiftCreateScreen from './screens/admin/WardPreShiftCreateScreen';
 
 
import SpsDashboardScreen        from './screens/admin/sps/SpsDashboardScreen';
import CpiRatesScreen            from './screens/admin/sps/CpiRatesScreen';
import CspRatesScreen            from './screens/admin/sps/CspRatesScreen';
import ImportPayDataScreen       from './screens/admin/sps/ImportPayDataScreen';
import PayRecordsBrowserScreen   from './screens/admin/sps/PayRecordsBrowserScreen';
import StaffDirectoryListScreen  from './screens/admin/sps/StaffDirectoryListScreen';
import StaffDirectoryEditScreen  from './screens/admin/sps/StaffDirectoryEditScreen';
import RunCalculatorScreen       from './screens/admin/sps/RunCalculatorScreen';
import RunHistoryScreen          from './screens/admin/sps/RunHistoryScreen';
import EmailCentreScreen         from './screens/admin/sps/EmailCentreScreen';
import EmailLogScreen            from './screens/admin/sps/EmailLogScreen';

import ImportDemographicsScreen from './screens/admin/sps/ImportDemographicsScreen';
import SingleSchemeQueryAnalyser from './screens/admin/emails/SingleSchemeQueryAnalyser';

import BouncedEmailAnalyser from './screens/admin/emails/BouncedEmailAnalyser';

import PrivacyPolicyScreen from './screens/legal/PrivacyPolicyScreen';





//<Route index={true} path='/' element={<HomeScreen />} /> 
 
const router = createBrowserRouter(
  createRoutesFromElements(
    <Route path='/' element={<App />}>
      <Route index={true} path='/' element={<LoginScreen />} />  {/* ← LoginScreen */}

      <Route path='/login' element={<LoginScreen />} />
      <Route path='/register' element={<RegisterScreen />} />
      <Route path='/ResetPassword' element={<ResetScreen />} /> 
      
      
      <Route path='/agencyregister' element={<AgencyRegisterScreen />} />   
      
      
      <Route path="/privacy" element={<PrivacyPolicyScreen />} />
 
 
       
      {/* Registered users */}
      <Route path='' element={<PrivateRoute />}>
        

         <Route path='/home' element={<HomeScreen />} />  {/* ← give it a real path */}


        <Route path='/search/:keyword' element={<HomeScreen />} />
        <Route path='/page/:pageNumber' element={<HomeScreen />} />
        <Route
          path='/search/:keyword/page/:pageNumber'
          element={<HomeScreen />}
        />

        

 
        <Route path='/arcade' element={<ArcadeScreen />} />
 
        <Route path='/shipping' element={<ShippingScreen />} />
        <Route path='/payment' element={<PaymentScreen />} />
        <Route path='/placeorder' element={<PlaceOrderScreen />} />
        <Route path='/order/:id' element={<OrderScreen />} />
        <Route path='/profile' element={<ProfileScreen />} />

        <Route path='/sps-profile' element={<SpsProfileScreen />} />
        
 
        <Route path="/my-availability" element={<StaffAvailabilityViewStaff />} />
        <Route path="/my-roster" element={<StaffRoster />} />
 
        <Route path='/worklist' element={<WorklistScreen />} />
        <Route path='/worklist/:id' element={<WorklistEditActivityScreen />} />
        <Route path='/worklist/:id/activity/:UKey' element={<WorklistEditItemScreen />} />
        <Route path='/manager/worklist/:id/activity/:UKey/:staffID' element={<WorklistEditItemScreenM />} />
        
        <Route path='/worklist/TreeMap' element={<TreeMapChart />} />
        
        
 
 
        <Route path='/worklist/:id/edit' element={<WorklistEditScreen />} />
 
        <Route path='/manager/approveWorklist' element={<ApproveWorklist />} />
        <Route path='/manager/approvedWorklist' element={<ApprovedWorklist />} />
        <Route path='/manager/worklist/:id/edit/:userID' element={<ApproveWorklistItem />} /> 
        <Route path='/manager/assignment' element={<ManagerAssignmentPrivilegesScreen />} />
        <Route path='/manager/assignmentView' element={<ManagerViewPrivilegesScreen/>} />
 
        <Route path='/manager/reports' element={<ManagerReports/>} />
        <Route path='/manager/reports/list' element={<ManagerReportsList/>} />
        <Route path='/manager/activityreport' element={<TreeMapMTeam/>} />
        
        <Route path='/manager/staffWeeklySchedule' element={<StaffWeeklyViewM />} />        
        <Route path='/manager/ward-weekly-schedule' element={<WardWeeklyViewM />} />
        <Route path='/manager/MonthlyCalendarView' element={<MonthlyCalendarViewM />} />
        <Route path="/manager/staff-availability" element={<StaffAvailabilityViewM />} />
         <Route path='/manager/shifts/create' element={<ShiftCreateScreenM />} />
 
         <Route path="/manager/approved-filled" element={<ShiftWardListScreenM />} /> 
        <Route path="/manager/shiftsWard/:id/edit" element={<ShiftWardEditScreenM />} />  
 
         <Route path='/manager/completed-shifts' element={<ShiftCompletedListScreenM />} />
        <Route path="/manager/dashboard" element={<ManagerDashboard />} />
 
       {/* <Route path="/manager/shifts" element={<ShiftListScreenM />} />  */}             
        <Route path="/manager/shifts/:id/edit" element={<ShiftEditScreenM />} /> 
        
        <Route path="/manager/ward-preshifts" element={<WardPreShiftListScreenM />} />
        <Route path="/manager/ward-preshifts/create" element={<WardPreShiftCreateScreenM />} />
 
 
 
        <Route path='/clinicalscommitmentlist' element={<UserClinicalSCommitmentListScreen />} />
        <Route
          path='/clinicalscommitmentlist/:pageNumber'
          element={<UserClinicalSCommitmentListScreen />}
        />
        <Route path='/clinicalscommitment/:id/edit' element={<UserClinicalSCommitmentEditScreen />} />
 
 
        
 
        <Route path='/spqualList' element={<SPQualListScreen />} />
 
        <Route path='/spqualList/:id/edit' element={<SPQualListScreen />} />
 
        <Route
          path='/spquallist/:pageNumber'
          element={<SPQualListScreen />}
        />
        <Route path='/spqualEdit/:id/edit/:myUserId' element={<SPQualEditScreen />} />
 
 
 
 
 
        <Route path='/radiationsafetylist' element={<UserRadiationSafetyListScreen />} />
        <Route
          path='/radiationsafetylist/:pageNumber'
          element={<UserRadiationSafetyListScreen />}
        />
        <Route path='/radiationsafety/:id/edit' element={<UserRadiationSafetyEditScreen />} />

        <Route path="/shiftRequests" element={<UserShiftRequestScreen />} /> 
 
      </Route>
 

 
      {/* ...   */}
{/* AuthMonitor will run globally across your application ,,, <AuthMonitor />  <InactivityTracker />*/}
 
 
      {/* Admin users */}
      <Route path='' element={<AdminRoute />}>
        <Route path='/admin/orderlist' element={<OrderListScreen />} />
        <Route path='/admin/productlist' element={<ProductListScreen />} />
        <Route
          path='/admin/productlist/:pageNumber'
          element={<ProductListScreen />}
        />
 
 {/* Admin Routes */}
 
        <Route path='/product/:id' element={<ProductScreen />} />
        <Route path='/cart' element={<CartScreen />} />
 
        <Route path="/admin/ward-preshifts" element={<WardPreShiftListScreen />} />
        <Route path="/admin/ward-preshifts/create" element={<WardPreShiftCreateScreen />} />
 
        <Route path="/admin/hospital-locations" element={<HospitalLocationScreen />} />
 
        <Route path="/admin/dashboard" element={<SchedulingDashboard />} />
 
        <Route path='/admin/staffWeeklySchedule' element={<StaffWeeklyView />} />
        
        <Route path='/admin/ward-weekly-schedule' element={<WardWeeklyView />} />
 
        <Route path='/admin/MonthlyCalendarView' element={<MonthlyCalendarView />} />
 
        <Route path="/admin/agencies" element={<AgencyListScreen />} />
        <Route path="/admin/agencies/create" element={<AgencyFormScreen />} />
        <Route path="/admin/agencies/:id/edit" element={<AgencyFormScreen />} />
        
        <Route path="/admin/agencylogin" element={<AgencyLoginScreen />} />
 
        <Route path='/admin/activitylist' element={<ActivityListScreen />} />
        <Route
          path='/admin/activitylist/:pageNumber'
          element={<ActivityListScreen />}
        />
        <Route path='/admin/clinicalsitelist' element={<ClinicalSiteListScreen />} />
        <Route
          path='/admin/clinicalsitelist/:pageNumber'
          element={<ClinicalSiteListScreen />}
        />
 
        <Route path='/admin/directoratelist' element={<DirectorateListScreen />} />
        <Route
          path='/admin/directoratelist/:pageNumber'
          element={<DirectorateListScreen />}
        />
        <Route path='/admin/locationlist' element={<LocationListScreen />} />
        <Route
          path='/admin/locationlist/:pageNumber'
          element={<LocationListScreen />}
        />
        <Route path='/admin/specialitylist' element={<SpecialityListScreen />} />
 
 
        <Route
          path='/admin/specialitylist/:pageNumber'
          element={<SpecialityListScreen />}
        />
 
      <Route path='/admin/Privileges' element={<PrivilegesListScreen />} />
 
      
      
      <Route path='/admin/shifts/create' element={<ShiftCreateScreen />} />
      <Route path="/admin/shifts" element={<ShiftListScreen />} />    
 
    <Route path="/admin/approved-filled" element={<ShiftWardListScreen />} /> 
    <Route path="/admin/shiftsWard/:id/edit" element={<ShiftWardEditScreen />} /> 
    <Route path="/admin/completed-shifts" element={<ShiftCompletedListScreen />} />
 
    
 
 
 
      <Route path="/admin/shifts/:id/edit" element={<ShiftEditScreen />} />
      
 
      <Route path="/admin/shiftRequests" element={<ShiftRequestScreen />} />  
      <Route path="/admin/shiftAgencyNotification" element={<ShiftRequestAgencyNotificationScreen />} />  
      <Route path="/admin/shiftRequestAgency" element={<ShiftRequestAgencyScreen />} />  
 
      <Route path="/admin/shiftApproval" element={<ShiftApproveScreen />} />  
      
 
 
 
 
      <Route path='/admin/Privileges/:id/list' element={<SpecialityPrivilegesListScreen />} />
      <Route path='/admin/Privilege/:id/edit' element={<PrivilegeEditScreen />} />
      <Route path='/admin/Privilege/:id/item/:privilegeID' element={<SpecialityPrivilegesEditScreen/>} />
 
      <Route path='/admin/privilege/assignment' element={<AssignmentPrivilegesScreen/>} />
      
 
 
        <Route path='/admin/clinicaldirectorlist' element={<ClinicalDirectorListScreen />} />
        <Route
          path='/admin/clinicaldirectorlist/:pageNumber'
          element={<ClinicalDirectorListScreen />}
        />
 
 
        <Route path='/admin/clinicalscommitmentlist' element={<ClinicalSCommitmentListScreen />} />
        <Route
          path='/admin/clinicalscommitmentlist/:pageNumber'
          element={<ClinicalSCommitmentListScreen />}
        />
 
      <Route path='/admin/RadAdmin/radiationsafetylist' element={<RadiationSafetyListScreen />} />
        <Route path='/admin/RadAdmin/radiationsafetylist/:StaffId/radList' element={<RadiationSafetyListScreen />} />
        <Route
          path='/admin/RadAdmin/radiationsafetylist/:pageNumber/:StaffId'
          element={<RadiationSafetyListScreen />} />
 
        <Route path='/admin/RadAdmin/radiationsafety/:id/edit' element={<RadiationSafetyEditScreen />} />
 
 
 
 
 
        <Route path='/admin/userlist' element={<UserListScreen />} />
        <Route path='/admin/userlist/Rad' element={<RadUserListScreen />} />
 
        <Route path='/admin/product/:id/edit' element={<ProductEditScreen />} />
 
        <Route path='/admin/activity/:id/edit' element={<ActivityEditScreen />} />
        <Route path='/admin/clinicalsite/:id/edit' element={<ClinicalSiteEditScreen />} />
 
        <Route path='/admin/directorate/:id/edit' element={<DirectorateEditScreen />} />
        <Route path='/admin/location/:id/edit' element={<LocationEditScreen />} />
        <Route path='/admin/speciality/:id/edit' element={<SpecialityEditScreen />} />
 
        <Route path='/admin/clinicaldirector/:id/edit' element={<ClinicalDirectorEditScreen />} />
        <Route path='/admin/clinicalscommitment/:id/edit' element={<ClinicalSCommitmentEditScreen />} />
 
 
 
        <Route path='/admin/user/:id/edit' element={<UserEditScreen />} />
        <Route path='/admin/user/Rad/:id/edit' element={<RadUserEditScreen />} />
 
        <Route path="/admin/staff-availability" element={<StaffAvailabilityView />} />
        <Route path="/admin/rolling-roster" element={<RollingRosterView />} />
        <Route path="/admin/audit-log" element={<AuditLogScreen />} />
        {/* SPS Pension Admin Routes */}
        <Route path='/admin/sps/dashboard'   element={<SpsDashboardScreen />} />
        <Route path='/admin/sps/cpi-rates'   element={<CpiRatesScreen />} />
        <Route path='/admin/sps/csp-rates'   element={<CspRatesScreen />} />
        <Route path='/admin/sps/import'      element={<ImportPayDataScreen />} />
        <Route path='/admin/sps/pay-records' element={<PayRecordsBrowserScreen />} />
        <Route path='/admin/sps/staff'       element={<StaffDirectoryListScreen />} />
        <Route path='/admin/sps/staff/:pps'  element={<StaffDirectoryEditScreen />} />
        <Route path='/admin/sps/run'         element={<RunCalculatorScreen />} />
        <Route path='/admin/sps/run-history' element={<RunHistoryScreen />} />
        <Route path='/admin/sps/email'       element={<EmailCentreScreen />} />
        <Route path='/admin/sps/email-log'   element={<EmailLogScreen />} />
        <Route path='/admin/sps/import-demographics' element={<ImportDemographicsScreen />} />

        
        <Route path='/admin/emails' element={<SingleSchemeQueryAnalyser />} />
        <Route path='/admin/bounced-emails' element={<BouncedEmailAnalyser />} />

 
      </Route>
    </Route>
  )
);
 
 
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <HelmetProvider>
      <Provider store={store}>
      
        <PayPalScriptProvider deferLoading={true}>
        <LayoutProvider>
          <RouterProvider router={router}>
          
          </RouterProvider>
          </LayoutProvider>
        </PayPalScriptProvider>
      </Provider>
    </HelmetProvider>
  </React.StrictMode>
);
 
 
reportWebVitals();
